import React from 'react'
import Body from './Body'
import Footer from './Footer'
import Header from './Header'

const Root = () => {
  return (
    <>      
    <Header/>
    <Body/>
    <Footer/>
    </>
  )
}

export default Root